<template>
  <div class="steps_pc" v-if="steps&&steps.length">
    <div :style="{'width':step_size,'color':item.done?'#9bd455':(item.current?'orange':'#bbb')}" v-for="(item,idx) in steps" :key="idx">
        <a-icon v-if="item.done" theme="twoTone" type="check-circle" :style="{fontSize:`${size}px`}" two-tone-color="#9bd455" class="icon2"/>
        <a-icon v-else-if="item.current" theme="twoTone" type="environment" :style="{fontSize:`${size+10}px`}" two-tone-color="orange" class="icon2 top"/>
        <a-icon v-else theme="twoTone" type="check-circle" :style="{fontSize:`${size}px`}" two-tone-color="#bbb" class="icon2"/>
        <p>{{item.name}}</p>
    </div>

    <p class="steps_line gray" :style="{'width':step_size_line_gray.wide,'left':step_size_line_gray.left,'top':`calc(9px + ${size/2}px)`}"></p>
    <p class="steps_line green" :style="{'width':step_size_line.wide,'left':step_size_line.left ,'top':`calc(9px + ${size/2}px)`}"></p>
  </div>
</template>

<script>
export default {
  data(){
      return{
        stepsTest:[
		{
			"name": "任务下发",
			"percent": 10,
			"status": null,
			"done": true,
			"current": null
		},
		{
			"name": "Web前端开发工程师开发",
			"percent": 20,
			"status": null,
			"done": true,
			"current": null
		},
		{
			"name": "UI工作确认",
			"percent": 40,
			"status": null,
			"done": true,
			"current": null
		},
		{
			"name": "方案编写",
			"percent": 50,
			"status": null,
			"done": true,
			"current": null
		},
		{
			"name": "功能开发工程师",
			"percent": 60,
			"status": null,
			"done": true,
			"current": null
		},
		{
			"name": "任务确认",
			"percent": 80,
			"status": null,
			"done": null,
			"current": true
		},
		{
			"name": "完成",
			"percent": 100,
			"status": null,
			"done": null,
			"current": null
		}
	]
    }
  },
  props:{
      steps:{
          type:Array,
          default:()=>{
              return []
          }
      },
      size:{
          type:Number,
          default:()=>{
              return 30
          }
      }
  },
  inject:['getDays','getLocalTime'],
  computed:{
      step_size(){
          let wide  = parseFloat(100 / this.steps.length).toFixed(2) - 0.1;
          return `${wide}%`;
      },
      step_size_line(){
          if(this.steps.length){
              let nowCur = 0;
              for(let i in this.steps){
                  if(this.steps[i].current){
                      nowCur = parseInt(i);
                  }
              }   
                let wide = nowCur * (parseFloat(100 / this.steps.length).toFixed(2) - 0.1);
                let left = parseFloat(100 / this.steps.length).toFixed(2) / 2;
                return {
                    wide:`calc(${wide}% - ${this.size/2}px)`,
                    left:`${left}%`
                }
          }
      },
      step_size_line_gray(){
          let wide  = 100 - parseFloat(100 / this.steps.length).toFixed(2);
          let left = parseFloat(100 / this.steps.length).toFixed(2) / 2;
          return {
              wide:`${wide}%`,
              left:`${left}%`
          }
      },
  },
}
</script>
<style>
.steps_pc{
    width:100%;
    font-size:13px;
    overflow:hidden;
    padding:10px 0px;
}
.steps_pc div{
    position:relative;
    float:left;
    text-align:center;
    z-index:99;
}
.steps_pc div .icon2{
    display:block;
}
.steps_pc div .icon2.top{
    margin-top:-10px;
}
.steps_pc p{
    margin:3px 0px;
}
.steps_pc .steps_line{
    position:absolute;
    top:37px;
    height:1px;
    z-index:20;
}
.steps_pc .steps_line.gray{
    background:#ddd;
}
.steps_pc .steps_line.green{
    background:#9bd455;
}
</style>



// WEBPACK FOOTER //
// src/components/todoCenter/stepsmini.vue